import { Component, input, OnInit } from "@angular/core";
import { getPluginMetadata, PluginMetadata } from "../../models/data/plugin-metadata";

@Component({
  selector: "installed-plugin-card",
  templateUrl: "./installed-plugin-card.component.html",
})
export class InstalledPluginCardComponent implements OnInit {
  pluginId = input.required<string>();

  plugin: PluginMetadata;

  ngOnInit() {
    this.plugin = getPluginMetadata(this.pluginId());
  }
}
